import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'

export type NewsType = 'feature' | 'fix' | 'improvement' | 'change' | string

export type NewsItem = {
  id: number
  number: number
  title: string
  description: string
  type: NewsType
  state: string
  closed_at: string | null
  published_at: string | null
  updated_at: string | null
}

const normalize = (payload: unknown): NewsItem[] => {
  const raw = Array.isArray(payload)
    ? payload
    : Array.isArray((payload as { data?: unknown })?.data)
      ? ((payload as { data: unknown[] }).data as unknown[])
      : []

  return raw
    .filter((entry): entry is NewsItem => {
      const item = entry as NewsItem | null
      return item != null && typeof item.id === 'number'
    })
    .sort((a, b) => publishedTime(b) - publishedTime(a))
}

export const publishedTime = (item: NewsItem) => {
  const stamp = item.published_at ?? item.updated_at ?? item.closed_at
  if (!stamp) return 0
  const parsed = Date.parse(stamp.replace(' ', 'T'))
  return Number.isNaN(parsed) ? 0 : parsed
}

export const NEWS_QUERY_KEY = ['config.news']

export function useQueryNews() {
  return useQuery<NewsItem[]>({
    queryKey: NEWS_QUERY_KEY,
    queryFn: async () => {
      const { data } = await axiosInstance.get('/config-api/news')
      return normalize(data)
    },
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
